import "../../../styles/Form.css";
import "es6-shim";
import '../Overview.css';
import * as React from "react";
import { MyleInstanceClinicSettings, PhoneCheckin } from "../../../dtos/KioskDtos.dtos";
import { IGenericsLang, ILabelSelect } from "../../../services/Language/Types";
import PatientDefault from "../../../services/Initializer/PatientDefaultInitializer";
import { IsArrayNullOrUndefinedOrEmpty } from "../../../utilities/Commons";
import { PhoneEdit } from "./PhoneEdit";
import { useMutateArrayState } from "../../../hooks/useMutateArrayState.hook";
import { PatientContactInfoEditFooter } from "./PatientContactInfoEditFooter";
import { useScrollEffectWhenMounted } from "../../../hooks/useScrollEffectWhenMounted.hook";

interface IPhonesEditContainerProps {
    defaultCountry: string;
    countryList: ILabelSelect[];
    phoneTypesOptions: ILabelSelect[];
    phones: PhoneCheckin[];
    text: IGenericsLang;
    focusedInputName: string;
    savePhones: (phones: PhoneCheckin[]) => void;
    cancel: () => void;
    onFocus: (pipe: (value: any) => void, value: any, mask: string, id: string) => void;
    disconnectKeyboard(): void;
    myleClinicSettings: MyleInstanceClinicSettings;
}

export const PhonesEditContainer = (props: IPhonesEditContainerProps) => {
    const [phones, mutatePhones] = useMutateArrayState<PhoneCheckin>(props.phones);

    const listContainer = useScrollEffectWhenMounted([phones.length])

    const onPhoneUpdate = (email: PhoneCheckin, index: number) => mutatePhones(phonesState => {
        if (email.isPreferred && phonesState.firstOrDefault(x => x.isPreferred) !== null) {
            phonesState.forEach((x, i) => {
                if (i !== index) {
                    x.isPreferred = false;
                }
            })
        };
        phonesState[index] = email;
    });

    const onPhoneDeletion = (index: number) => mutatePhones(phonesState => {
        const elementToRemove = phonesState[index];
        phonesState.splice(index, 1)
        if (elementToRemove.isPreferred && !phonesState.isEmpty()) {
            phonesState[0].isPreferred = true;
        };
    });

    const onPhoneAdd = () => mutatePhones(phonesState => {
        const newPhone = PatientDefault.newPhone(props.defaultCountry);
        if (phonesState.isEmpty()) {
            newPhone.isPreferred = true;
        }
        phonesState.push(newPhone)
    });

    const isFormValid = () => {
        if (IsArrayNullOrUndefinedOrEmpty(phones)) {
            return true;
        }
        for (const phone of phones) {
            if (phone.number.length < 7) {
                return false;
            };
        }
        return true;
    };

    return (
        <div>
            <div className="col-sm-12 contact-info-edit-container" ref={listContainer}>
                {
                    phones.map((phone, index) => (
                        <div className="row" key={"phone-edit-" + index}>
                            <PhoneEdit
                                index={index}
                                phone={phone}
                                countryList={props.countryList}
                                defaultCountry={props.defaultCountry}
                                phoneTypesOptions={props.phoneTypesOptions}
                                text={props.text}
                                focusedInputName={props.focusedInputName}
                                onDeletePhone={() => onPhoneDeletion(index)}
                                onPhoneEdit={editedPhone => onPhoneUpdate(editedPhone, index)}
                                onFocus={props.onFocus}
                                disconnectKeyboard={props.disconnectKeyboard}
                                myleClinicSettings={props.myleClinicSettings}
                            />
                        </div>
                    ))
                }
            </div>
            <PatientContactInfoEditFooter
                text={props.text.labels}
                addElementTextLabel={props.text.labels.AddPhoneLabel}
                isFormValid={isFormValid()}
                onAddElementClick={onPhoneAdd}
                onCancelClick={props.cancel}
                onSaveElementsClick={() => props.savePhones(phones)}
            />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/PatientOverview/EditComponents/PhonesEditContainer.tsx